const Footer = () => {
    return (
        <footer className={'py-2'}>
            <span className={'text-center'}><p>{`En Micro - ${new Date().getFullYear()} 💖`}</p></span>
        </footer>
    );
}
export default Footer;